module.exports = __webpack_public_path__ + "site/img/function6.cbdf0cf.png";


//////////////////
// WEBPACK FOOTER
// ./site/function6.png
// module id = 102
// module chunks = 1